import { IsOptional, IsBoolean } from 'class-validator';

export class MarkReadAllDto {
  @IsBoolean()
  @IsOptional()
  removeFromList?: boolean;
}
